import { Dispatch, SetStateAction } from "react";

import { FiasAddress } from "./Utils/FiasAddressUtils";

export interface FiasTestPageObjectType {
    openDropDown?: () => void;
    closeDropDown?: () => void;
    handleFocus?: () => void;
    setSelectIndex?: (index: number) => void;
    applySelectedItemForTestPageObject?: (index: number) => boolean;
}

export const FiasTestPageObject = (
    value: FiasAddress,
    setMode: Dispatch<SetStateAction<"edit" | "show">>,
    onChangeHandler: (currentText: string) => void,
    fiasInputMethods: FiasTestPageObjectType = {}
) => ({
    getType: () => "Fias",

    getValue: () => value,

    setValue: (currentText: string) => onChangeHandler(currentText),

    setEditMode: () => setMode("edit"),

    openDropDown: () => fiasInputMethods.openDropDown?.(),

    closeDropDown: () => fiasInputMethods.closeDropDown?.(),

    handleFocus: () => fiasInputMethods.handleFocus?.(),

    setSelectIndex: (index: number) => fiasInputMethods.setSelectIndex?.(index),

    applySelectedItem: async (index: number): Promise<boolean> => {
        fiasInputMethods.handleFocus?.();
        const isSuccess = fiasInputMethods.applySelectedItemForTestPageObject?.(index);
        return isSuccess ?? false;
    },
});
